import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { ScheduleModel } from '../models/schedule.model';
import { SubScheduleModel } from '../models/subschedule.model';
import { SaveScheduleData } from '../models/SaveScheduleData.model';
import { InfraService } from './infra.service';





@Injectable(
)
export class ScheduleService {
  private configUrl: string;
  private apiCoreUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'schedule';
      this.apiCoreUrl = data.WebEndPoint2;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }


	  // tslint:disable-next-line: indent
  public getSchedules(engagementId: number, fromMonth: number, fromYear: number, toMonth: number, toYear: number, isDynamicDatabook: boolean) {
    return this.http.get<any>(`${this.apiCoreUrl}DataBook/GetSchedules/${engagementId}/${fromMonth}/${fromYear}/${toMonth}/${toYear}/${isDynamicDatabook}`);
    // .catch(this.handleError);
  }
 

  public getMonthYear(Id: number) {
    return this.http.get(`${this.apiCoreUrl}DataBook/getMonthYear/${Id}`);
    // .catch(this.handleError);
  }

  public createEngagementSchedule(scheduleData: SaveScheduleData) {
    return this.http.post<SaveScheduleData>(`${this.apiCoreUrl}DataBook/scheduleData`, scheduleData);
    // .catch(this.handleError);
  }


  public updateIsFinishEngagement(engagementId: number) {
    return this.http.get(`${this.apiCoreUrl}Engagement/UpdateIsFinish/${engagementId}`);
  }

  //public updateForcastDetailsEngagement(engagementId: number, isForecastAvailable: boolean, forecastMonth: number , forecastYear: number ) {
  //  return this.http.get(`${this.apiCoreUrl}Engagement/UpdateForecastDetails/${engagementId}/${isForecastAvailable}/${forecastMonth}/${forecastYear}`);
  //}

  public checkDuplicateAccountDescription(engagementId: number) {
      return this.http.get(`${this.apiCoreUrl}DataBook/checkDuplicateAccountDescription/${engagementId}`);
  }

  public resetDatabook(engagementId: number) {
    return this.http.post(`${this.apiCoreUrl}DataBook/resetDatabook/${engagementId}`, {});
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
